import React, {Component} from "react";
import {Panel} from "react-bootstrap";
import * as messageConstants from "../../shared/messages";
import './index.scss';

export class AzureAdTableEmpty extends Component {
  render() {
    return (
        <Panel>
          <Panel.Body className="azuread-clients-panel-body">
            <h3 className='empty-table-title text-center'>
              {messageConstants.YOU_HAVE_NO_INTEGRATIONS}
            </h3>
          </Panel.Body>
        </Panel>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AzureAdList/AzureAdTableEmpty.js